import { scan } from 'react-scan'; // must be imported before React and React DOM
import React from 'react';
import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client' instead of 'react-dom'
import { Provider } from 'react-redux';
import debug from 'debug';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './globals.css'; // Import Tailwind CSS styles
import './i18n/i18n'; // Initialize i18n
import App from './App';
import { store } from './store';
import { config } from '../config';
// import GlobalErrorBoundary from './GlobalErrorBoundary';
import { reportError } from './lib/errorReports';
import { FeatureFlagProvider } from './providers/FeatureFlagsProvider';
import { cleanupOldBackups } from './lib/recovery';
import { ThumbnailCacheProvider } from './contexts/ThumbnailCacheContext';
import { initializeSentry, Sentry } from './lib/sentry';

scan({
  enabled: config.enableReactScan,
});

// Initialize Sentry
initializeSentry();

debug.enable(config.debug);
const log = debug('app:index');

window.displayVersionInfo = () => {
  const buildTime = new Date(config.buildTime);

  log(
    `%cScreenApp ${config.appEnv}`,
    'font-size: 20px; background-color: black; font-weight: bold; color: white;',
  );

  log(
    `%cBuild Time: ${buildTime}`,
    'font-size: 14px; background-color: black; font-weight: bold; color: white;',
  );

  log(
    `%c${config.version}%c-${config.appEnv.toLocaleLowerCase()}%c+${
      config.commit
    }`,
    'font-size: 20px; background-color: black; color: #db2777;',
    'font-size: 20px; background-color: black; color: #f472b6;',
    'font-size: 20px; background-color: black; color: #fbcfe8;',
  );
};

window.displayVersionInfo();

window.onerror = function handleGlobalError(
  message,
  source,
  lineno,
  colno,
  error,
) {
  // SA-991 No effect from this error
  if (message !== 'ResizeObserver loop limit exceeded') {
    reportError('window.onerror', {
      message,
      source,
      lineno,
      colno,
      error,
    });
  }

  // return true to indicate the error was handled
  return false;
};

window.onunhandledrejection = function handleGlobalError(event) {
  const error = event.reason;

  reportError('window.onunhandledrejection', {
    // Error message or whatever in here is lost when passing to reportError
    error,
  });

  return false;
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
const root = ReactDOM.createRoot(rootElement); // Create a root using ReactDOM.createRoot

root.render(
  <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
    <Provider store={store}>
      <FeatureFlagProvider>
        <ThumbnailCacheProvider>
          <App />
          <div id="screenapp-recorder" />
        </ThumbnailCacheProvider>
      </FeatureFlagProvider>
    </Provider>
  </Sentry.ErrorBoundary>,
);

cleanupOldBackups();

// Register service worker
serviceWorkerRegistration.register();
